import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, startScreenTimeTracking, stopScreenTimeTracking, enableClickTracking } from '../services/tracking';

const PageTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageView(
      location.pathname + location.search,
      document.title,
      document.referrer
    );

    // Start screen time tracking
    startScreenTimeTracking(location.pathname);

    // Enable click tracking
    enableClickTracking();

    // Cleanup on unmount or route change
    return () => {
      stopScreenTimeTracking();
    };
  }, [location]);

  return null;
};

export default PageTracker;








